// src/slices/componentSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createComponent, fetchComponents, updateComponent } from '../actions/componentActions';

const componentSlice = createSlice({
  name: 'components',
  initialState: {
    components: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createComponent.pending, (state) => {
        state.loading = true;
      })
      .addCase(createComponent.fulfilled, (state, action) => {
        state.loading = false;
        state.components.push(action.payload);
      })
      .addCase(createComponent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchComponents.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchComponents.fulfilled, (state, action) => {
        state.loading = false;
        state.components = action.payload; // Store the fetched components
      })
      .addCase(fetchComponents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        
      })
      .addCase(updateComponent.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateComponent.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload;
        const index = state.components.findIndex((c) => c.id === updated.id);
        if (index !== -1) {
          state.components[index] = updated;
        }
      })
      .addCase(updateComponent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default componentSlice.reducer;
